(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-flyout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mega-menu-flyout')) {
    customElements.define(
      'mega-menu-flyout',
      class extends HTMLElement {
        /* A pointer crossing a family on its way to the right pane must not switch panes. */
        static HOVER_DELAY_MS = 120;

        connectedCallback() {
          this.families = [...this.querySelectorAll('[data-flyout-family]')];
          this.timer = undefined;
          this.addEventListener('pointerover', this.onPointerOver);
          this.addEventListener('pointerleave', this.onPointerLeave);
          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeyDown);
        }

        familyOf(target) {
          return target instanceof Element ? target.closest('[data-flyout-family]') : null;
        }

        show(family) {
          if (!family || family.ariaExpanded === 'true') return;
          for (const f of this.families) {
            const on = f === family;
            f.ariaExpanded = on.toString();
            document.getElementById(f.getAttribute('aria-controls'))?.toggleAttribute('data-active', on);
          }
        }

        onPointerOver = (event) => {
          const family = this.familyOf(event.target);
          clearTimeout(this.timer);
          if (!family || event.pointerType === 'touch') return;
          this.timer = setTimeout(() => this.show(family), this.constructor.HOVER_DELAY_MS);
        };

        onPointerLeave = () => clearTimeout(this.timer);

        onFocusIn = (event) => this.show(this.familyOf(event.target));

        /* Touch: the first tap on a family opens its leaves; a tap on the open family follows its link. */
        onClick = (event) => {
          const family = this.familyOf(event.target);
          if (!family || family.ariaExpanded === 'true') return;
          event.preventDefault();
          this.show(family);
        };

        onKeyDown = (event) => {
          const family = this.familyOf(event.target);
          const i = this.families.indexOf(family);
          if (family && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
            event.preventDefault();
            const n = this.families.length;
            this.families[(i + (event.key === 'ArrowDown' ? 1 : n - 1)) % n].focus();
          } else if (family && event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(family);
            document.getElementById(family.getAttribute('aria-controls'))?.querySelector('a')?.focus();
          } else if (!family && event.key === 'ArrowLeft') {
            const open = this.families.find((f) => f.ariaExpanded === 'true');
            if (open) {
              event.preventDefault();
              open.focus();
            }
          }
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
